import { Network } from "src/app/ui/models/domains/pbm/Benefit/network";
import { PdvCycleItem } from "src/app/ui/models/domains/pbm/network-financial-statement/pdv-cycle-item";
import { PdvFinancialStatement } from "src/app/ui/models/domains/pbm/network-financial-statement/pdv-financial-statement";

export function parsePdvFinancialStatementList(payload: any): PdvFinancialStatement[] {
  return payload.map((item) => {
    return new PdvFinancialStatement(parseNetwork(item.Network), parsePdvCycleItemList(item.Items));
  });
}

export function parseNetwork(payload: any): Network {
  const network = new Network();
  network.setCorporateName(payload.CorporateName);
  network.setFiscalNumber(payload.FiscalNumber.Value);
  network.setTradingName(payload.TradingName);
  return network;
}

export function parsePdvCycleItemList(payload: any): PdvCycleItem[] {
  return payload.map((item) => {
    return new PdvCycleItem(
      item.ReferenceMonth,
      item.Period.Start,
      item.Period.End,
      item.PaymentDate,
      item.TotalPaymentValue,
      item.TotalCardValue,
      item.TotalAdministrativeTax,
    );
  });
}
